import { styled } from "@mui/material/styles";

const TabContainer = styled("section")({
  display: "flex",
  gap: "24px",
});

const TabItem = styled("span")(({ theme, isSelected }) => ({
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "21.6px",
  letterSpacing: "0.5px",
  color: "#171717",
  cursor: "pointer",
  paddingBottom: "5px",
  borderBottom: isSelected ? `2px solid #171717` : "none",
  transition: "border-bottom 0.3s ease",
}));

const Tabs = ({ LeftTabSelected, SetLeftTabSelected }) => {
  const handleTabSelection = (isAllTab) => {
    SetLeftTabSelected(isAllTab);
  };

  return (
    <TabContainer>
      <TabItem
        isSelected={LeftTabSelected}
        onClick={() => handleTabSelection(true)}
      >
        ALL
      </TabItem>
      <TabItem
        isSelected={!LeftTabSelected}
        onClick={() => handleTabSelection(false)}
      >
        FAVORITES
      </TabItem>
    </TabContainer>
  );
};

export default Tabs;
